import { BaseResponse } from 'common/types/api'
import axios from 'core/api'

import { ActivePolicyDocument, ConsentStatusResponse, PolicyConsentResponse } from './types'

export const getActivePolicyDocuments = () =>
  axios.get<BaseResponse<ActivePolicyDocument[]>>('/policy-documents/active')

export const getPolicyConsentStatus = () =>
  axios.get<BaseResponse<ConsentStatusResponse>>('/policy-documents/consent-status')

export const consentPolicyDocument = (policyDocumentId: string) =>
  axios.post<BaseResponse<PolicyConsentResponse>>(`/policy-documents/${policyDocumentId}/consent`)

// Note: content_url is NOT fetched from JS — the blob storage account has no
// CORS rules, so browsers block the fetch. It is rendered via a sandboxed
// iframe instead (see components/PolicyHtmlContent.tsx).
